export const SAT_COURSES = {
  SAT_DEMO: 'SAT-DEMO',
  SAT_MATH: 'SAT-MATH',
  SAT_ENGLISH: 'SAT-ENGLISH',
  SAT_TESTS: 'SAT-TESTS',
} as const;

export const PROGRAM_STREAM_TYPE = {
  MATH: 'MATH',
  CODING: 'CODING',
  ELA: 'ELA',
  SCIENCE: 'SCIENCE',
  ...SAT_COURSES,
} as const;

export const CUE_PROGRAM_TYPE = {
  ELECTIVES: 'ELECTIVES',
  CORE: 'CORE',
} as const;

export const CURRICULUM_TABS = {
  CHAPTER: 'chapters',
  PUZZLE: 'puzzles',
  PRACTICE: 'practice',
} as const;

export const CLASS_ACCESS_USER_ONLY_TABS = [
  CURRICULUM_TABS.PUZZLE,
  CURRICULUM_TABS.PRACTICE,
];
